import { configureStore } from '@reduxjs/toolkit';
import createDebounce from 'redux-debounced';
import rootReducer from '../reducers/rootReducer';
import { certificationListener, sustainabilityListener } from '../middleware';
import sustainabilityApi from '../apis/sustainability.api';
import certificationApi from '../apis/certification.api';
import goodYouDoApi from '../apis/good-you-do.api';

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredPaths: ['profileReducer']
			},
			immutableCheck: false
		})
			.concat(createDebounce())
			.concat(sustainabilityApi.middleware)
			.concat(certificationApi.middleware)
			.concat(goodYouDoApi.middleware)
			.prepend(sustainabilityListener.middleware, certificationListener.middleware),

	// Optional — keeps Redux DevTools working automatically
	devTools: process.env.NODE_ENV !== 'production'
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
